export const normalizeCalendarDate = (date?: string): string => {
  if (!date) return ''

  const [year, month, day] = date.includes('/')
    ? date.split('/')
    : date.split('-')

  return `${year}/${month.padStart(2, '0')}/${day.padStart(2, '0')}`
}
